import { postAction } from './postAction'

// Redrives tenant_group events for every tenant group. The endpoint takes no body
// and no params — there is currently no way to scope it to specific groups.
export async function redriveTenantGroup(token: string): Promise<string> {
  await postAction('/v1/act/redrive/tenant_group', token)
  return 'Tenant group redrive request accepted for all tenant groups.'
}
